import {Button} from '@dropbox/dig-components/buttons';
import {Text} from '@dropbox/dig-components/typography';
import {Box, Split, Stack} from '@dropbox/dig-foundations';
import ReplitLogo from 'assets/logos/replit.svg?react';
import {snackbarAtom} from 'atoms/snackbar';
import {Layout} from 'components/DSYS/Layout';
import {Title} from 'components/DSYS/Title';
import {ROUTE_PATHS} from 'constant';
import {useDocumentTitle} from 'hooks/useDocumentTitle';
import {t} from 'i18next';
import {useSetAtom} from 'jotai';
import {useCallback} from 'react';
import {useNavigate} from 'react-router';

import {appPublishSuccessSnackbar} from './appPublishSnackbar';
import styles from './Apps.module.css';
import {REPLIT_CREATE_URL} from './appUtils';
import {AppPublishResult} from './publishApp';
import {UploadDropzone} from './UploadDropzone';

export const CreateApp: React.FC = () => {
  const navigate = useNavigate();
  const setSnackbar = useSetAtom(snackbarAtom);
  useDocumentTitle(t('apps_upload_site'));

  const handlePublishSuccess = useCallback(
    (result: AppPublishResult) => {
      setSnackbar(appPublishSuccessSnackbar(result));
      navigate(ROUTE_PATHS.APPS);
    },
    [navigate, setSnackbar]
  );

  return (
    <Layout.Container
      breadcrumb={[
        {children: t('apps'), to: ROUTE_PATHS.APPS},
        {children: t('apps_upload_site'), to: ROUTE_PATHS.APPS_NEW},
      ]}
    >
      <Split alignY="center" gap="16" className={styles.stackedOnMobile}>
        <Split.Item width="fill">
          <Stack gap="8">
            <Title size={24}>{t('apps_upload_site')}</Title>
            <Text color="subtle">{t('apps_create_description')}</Text>
          </Stack>
        </Split.Item>
        <Split.Item>
          <Button
            href={REPLIT_CREATE_URL}
            rel="noopener noreferrer"
            target="_blank"
            variant="outline"
            withIconStart={<ReplitLogo aria-hidden className={styles.createInReplitLogo} />}
          >
            {t('apps_create_in_replit')}
          </Button>
        </Split.Item>
      </Split>

      <Box paddingTop="24">
        <UploadDropzone onPublishSuccess={handlePublishSuccess} />
      </Box>
    </Layout.Container>
  );
};
